import _mergeJSXProps4 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps3 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { defaultDesignerFlags } from '../ucBus/components';
import { startMouseMove } from "../../lib/utils";
import { INJECT_UICORE_DESIGNER } from "../../lib/utils/consts";
import { CalmComputedGetter, vueDeepAssign } from "../../lib/utils/vue";
import { clamp } from "lodash-es";
let AbsolutePositioningTool = class AbsolutePositioningTool extends Vue {
  constructor() {
    super(...arguments);
    /** 拖拽期间展示的临时文字 */
    this.tempValue = '';
    /** 4条参考线 横向两条线负left 向editZone左侧对齐
     * 纵向两条线负top
     */
    this.guideLineStyle = {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    };
  }
  get canAdjustAbsolutePosition() {
    return this.ownerBlock.canAdjustAbsolutePosition;
  }
  handleResizeMouseDown(opts, ev) {
    const {
      compElement,
      compPath,
      designer
    } = this.ownerBlock;
    if (!compElement) return;
    const rawWidthNum = compElement.offsetWidth;
    const rawHeightNum = compElement.offsetHeight;
    const oldCssWidth = compElement.style.width;
    const oldCssHeight = compElement.style.height;
    let newWidth = '';
    let newHeight = '';
    setTimeout(() => {
      this.designer.compPath = compPath; // 不然会选中其他组件
    }, 100);
    this.designer.currentOperation = 'resizing';
    this.tempValue = '请拖拽调整大小';
    ev.stopPropagation();
    const moveStartTime = Date.now();
    startMouseMove({
      initialEvent: ev,
      onMove: ({
        deltaX,
        deltaY,
        event
      }) => {
        let dX = deltaX;
        let dY = deltaY;
        // 按着 shift 等比缩放
        if ((event.shiftKey || this.designerFlags.keepAspectRatio) && opts.width && opts.height) {
          const d = (deltaX * rawWidthNum + deltaY * rawHeightNum) / (rawHeightNum + rawWidthNum);
          dX = Math.round(d);
          dY = Math.round(d * (rawHeightNum / rawWidthNum));
        }
        // const skeletonEl = this.ownerBlock.$el as HTMLElement;   // 这种做法遇到需要居中对齐的地方会出问题
        // 显示的宽高进行px取整
        dX = Math.round(dX / this.designer.getZoomPercentage());
        dY = Math.round(dY / this.designer.getZoomPercentage());
        if (opts.width) {
          const newWidthPx = Math.max(rawWidthNum + dX, 1);
          newWidth = `${newWidthPx}px`;
          if (this.designerFlags.adjustMinWidth) compElement.style.minWidth = newWidth;
          compElement.style.width = newWidth;
          // skeletonEl.style.width = `${newWidth}px`;
        }
        if (opts.height) {
          const newHeightPx = Math.max(rawHeightNum + dY, 1);
          newHeight = `${newHeightPx}px`;
          if (this.designerFlags.adjustMinHeight) compElement.style.minHeight = newHeight;
          compElement.style.height = newHeight;
          // skeletonEl.style.height = `${newHeight}px`;
        }
        this.tempValue = `${newWidth || oldCssWidth || '--'} X ${newHeight || oldCssHeight || '--'}`;
        this.ownerBlock.syncStyle();
        // 同步参考线的位置
        this.refreshGuidLinesPosition(opts);
      },
      onEnd: async ({
        deltaX,
        deltaY
      }) => {
        this.designer.currentOperation = '';
        this.tempValue = '';
        const moveDeltaTime = (Date.now() - moveStartTime) / 1000;
        // 如果我拖了1秒那就不是误操作了 每个像素的变化都要记录
        const pxThreshold = moveDeltaTime < 1 ? 5 : 1;
        const newStyle = {};
        if (opts.width && newWidth) {
          compElement.style.width = oldCssWidth;
          if (Math.abs(deltaX) >= pxThreshold) {
            if (this.designerFlags.adjustMinWidth) {
              newStyle.minWidth = newWidth;
            } else {
              newStyle.width = newWidth;
            }
          }
        }
        if (opts.height && newHeight) {
          compElement.style.height = oldCssHeight;
          if (Math.abs(deltaY) >= pxThreshold) {
            if (this.designerFlags.adjustMinHeight) {
              newStyle.minHeight = newHeight;
            } else {
              newStyle.height = newHeight;
            }
          }
        }
        await designer.modifyComp(compPath, comp => {
          vueDeepAssign(comp, {
            style: newStyle
          });
        });
        designer.uc.flushPageletsChange();
        this.ownerBlock.syncStyle();
      }
    });
  }
  handleMoveMouseDown(ev) {
    const {
      compElement,
      compPath,
      designer,
      ownerSlotContainerElement,
      isInAbsoluteSlot
    } = this.ownerBlock;
    if (!compElement) return;
    const rawTransform = compElement.style.transform;
    const originLeft = compElement.offsetLeft;
    const originTop = compElement.offsetTop;
    setTimeout(() => {
      designer.compPath = compPath; // 不然会选中其他组件
    }, 100);
    this.designer.currentOperation = 'positioning';
    ev.stopPropagation();
    const zoom = this.designer.getZoomPercentage();
    startMouseMove({
      initialEvent: ev,
      onMove: ({
        deltaX,
        deltaY
      }) => {
        compElement.style.transform = `${rawTransform || ''} translate(${deltaX / zoom}px, ${deltaY / zoom}px)`;
        this.ownerBlock.syncStyle();
        this.refreshGuidLinesPosition({
          width: true,
          height: true
        });
      },
      onEnd: async ({
        deltaX,
        deltaY
      }) => {
        this.designer.currentOperation = '';
        if (deltaX !== 0 || deltaY !== 0) {
          const changeOffset = async (left, top) => await designer.modifyComp(compPath, comp => {
            vueDeepAssign(comp, {
              style: {
                left: `${Math.round(left)}px`,
                top: `${Math.round(top)}px`
              }
            });
          });
          // 绝对定位插槽中 阻止拖动溢出插槽
          if (isInAbsoluteSlot) {
            const {
              width,
              height
            } = ownerSlotContainerElement.getBoundingClientRect();
            const {
              width: compWidth,
              height: compHeight
            } = compElement.getBoundingClientRect();
            const left = clamp(originLeft + deltaX / zoom, 0, (width - compWidth) / zoom);
            const top = clamp(originTop + deltaY / zoom, 0, (height - compHeight) / zoom);
            await changeOffset(left, top);
          } else {
            await changeOffset(originLeft + deltaX / zoom, originTop + deltaY / zoom);
          }
        }
        designer.uc.flushPageletsChange();
        compElement.style.transform = rawTransform;
        this.ownerBlock.syncStyle();
      }
    });
  }
  handleDragStart(ev) {
    ev.preventDefault();
    ev.stopPropagation();
  }
  /* 拖拽边框可以移动 */
  get borderForMoving() {
    const h = this.$createElement;
    const {
      handleMoveMouseDown,
      handleDragStart,
      canAdjustAbsolutePosition
    } = this;
    // 两个模式：要么绝对定位调整位置，要么 Drag 调整组件在DOM的结构位置
    const eventListeners = canAdjustAbsolutePosition ? {
      mousedown: handleMoveMouseDown,
      touchstart: handleMoveMouseDown,
      dragstart: handleDragStart
    } : {
      mousedown: ev => {
        // 点击事件不要冒泡出去，避免选中其他的组件
        ev.stopPropagation();
      },
      dragstart: this.ownerBlock.startDraggingBlock,
      dragend: this.ownerBlock.stopDraggingBlock
    };
    return ['atTop', 'atBottom', 'atLeft', 'atRight'].map(pos => h("div", _mergeJSXProps([{
      "class": `ucd-absPosTool-border ${canAdjustAbsolutePosition ? 'canAdjustAbsolutePosition' : ''} ${pos}`,
      "key": pos,
      "attrs": {
        "draggable": true
      }
    }, {
      "on": eventListeners
    }])));
  }
  refreshGuidLinesPosition(opts) {
    const compElement = this.ownerBlock.compElement;
    const editZoneEl = this.designer.$refs.editZone.$el;
    if (!(compElement !== null && compElement !== void 0 && compElement.getBoundingClientRect) || !(editZoneEl !== null && editZoneEl !== void 0 && editZoneEl.getBoundingClientRect)) return;
    // canvasWrapper的padding是8 防止参考线自己把宽度撑开
    const canvasPadding = 8;
    const {
      top,
      left
    } = compElement.getBoundingClientRect();
    const {
      top: topEdit,
      left: leftEdit
    } = editZoneEl.getBoundingClientRect();
    this.guideLineStyle.left = -(left - leftEdit || 0);
    this.guideLineStyle.top = -(top - topEdit || 0);
    const {
      width,
      height
    } = editZoneEl.getBoundingClientRect();
    this.guideLineStyle.width = opts.height ? width - canvasPadding * 2 : 0;
    this.guideLineStyle.height = opts.width ? height - canvasPadding : 0;
  }
  get getGuideLineStyle() {
    // number 转 'number+px'
    const {
      left,
      width,
      height,
      top
    } = Object.entries(this.guideLineStyle).reduce((obj, [key, value]) => (obj[key] = `${value}px`, obj), {});
    return {
      atLeftGuide: {
        top,
        height
      },
      atRightGuide: {
        top,
        height
      },
      atTopGuide: {
        left,
        width
      },
      atBottomGuide: {
        left,
        width
      }
    };
  }
  get guideLines() {
    const h = this.$createElement;
    return Object.entries(this.getGuideLineStyle).map(([pos, style]) => h("div", {
      "class": `ucd-absPosTool-guideLines  ${pos}`,
      "style": style,
      "key": pos
    }));
  }
  async removeStyles(styleNames) {
    this.designer.modifyComp(this.ownerBlock.compPath, comp => {
      if (!comp.style) return;
      styleNames.forEach(s => {
        this.$delete(comp.style, s);
      });
    });
  }
  get designerFlags() {
    var _this$ownerBlock$vNod;
    return ((_this$ownerBlock$vNod = this.ownerBlock.vNodeFactoryState) === null || _this$ownerBlock$vNod === void 0 ? void 0 : _this$ownerBlock$vNod.getDesignerFlags()) || defaultDesignerFlags;
  }
  render() {
    var _this$ownerBlock$layo;
    const h = arguments[0];
    const {
      handleDragStart
    } = this;
    const handleResizeWidthMouseDown = this.handleResizeMouseDown.bind(this, {
      width: true
    });
    const handleResizeHeightMouseDown = this.handleResizeMouseDown.bind(this, {
      height: true
    });
    const handleResizeBothMouseDown = this.handleResizeMouseDown.bind(this, {
      width: true,
      height: true
    });
    const {
      borderForMoving,
      designerFlags,
      tempValue,
      guideLines
    } = this;
    const currentStyle = ((_this$ownerBlock$layo = this.ownerBlock.layout) === null || _this$ownerBlock$layo === void 0 ? void 0 : _this$ownerBlock$layo.style) || {};
    const hasWidth = !!currentStyle.width;
    const hasHeight = !!currentStyle.height;
    const operation = this.designer.currentOperation;
    const displayGuildeLines = operation === 'resizing' || operation === 'positioning';
    return h("div", {
      "class": "ucd-absPosTool"
    }, [!!tempValue && h("div", {
      "class": "ucd-absPosTool-tempValueDisplay"
    }, [h("div", {
      "class": "ucd-absPosTool-tempValueDisplay-sizeDiv"
    }, [tempValue])]), (this.canAdjustAbsolutePosition || this.ownerBlock.isDraggable) && borderForMoving, displayGuildeLines && guideLines, designerFlags.allowAdjustWidth && h("div", _mergeJSXProps2([{
      "key": "resizeWidth",
      "class": `ucd-absPosTool-resize resizeWidth ${hasWidth ? 'hasValue' : ''}`,
      "attrs": {
        "title": hasWidth ? `已配置宽度${currentStyle.width}，双击可清除` : '',
        "draggable": true
      }
    }, {
      "on": {
        dblclick: () => this.removeStyles(['width']),
        mousedown: handleResizeWidthMouseDown,
        touchstart: handleResizeWidthMouseDown,
        dragstart: handleDragStart
      }
    }])), designerFlags.allowAdjustHeight && h("div", _mergeJSXProps3([{
      "key": "resizeHeight",
      "class": `ucd-absPosTool-resize resizeHeight ${hasHeight ? 'hasValue' : ''}`,
      "attrs": {
        "title": hasHeight ? `已配置高度${currentStyle.height}，双击可清除` : '',
        "draggable": true
      }
    }, {
      "on": {
        dblclick: () => this.removeStyles(['height']),
        mousedown: handleResizeHeightMouseDown,
        touchstart: handleResizeHeightMouseDown,
        dragstart: handleDragStart
      }
    }])), designerFlags.allowAdjustWidth && designerFlags.allowAdjustHeight && h("div", _mergeJSXProps4([{
      "key": "resizeBoth",
      "class": `ucd-absPosTool-resize resizeBoth ${hasWidth || hasHeight ? 'hasValue' : ''}`,
      "attrs": {
        "title": hasWidth || hasHeight ? `已配置尺寸(${currentStyle.width || '?'} x ${currentStyle.height || '?'})，双击可清除` : '',
        "draggable": true
      }
    }, {
      "on": {
        dblclick: () => this.removeStyles(['width', 'height']),
        mousedown: handleResizeBothMouseDown,
        touchstart: handleResizeBothMouseDown,
        dragstart: handleDragStart
      }
    }]))]);
  }
};
__decorate([CalmComputedGetter()], AbsolutePositioningTool.prototype, "getGuideLineStyle", null);
AbsolutePositioningTool = __decorate([Component({
  name: 'AbsolutePositioningTool',
  inject: {
    designer: {
      from: INJECT_UICORE_DESIGNER
    }
  },
  props: {
    ownerBlock: {
      type: Object,
      required: true
    }
  }
})], AbsolutePositioningTool);
export default AbsolutePositioningTool;
//# sourceMappingURL=AbsolutePositioningTool.js.map
